/*-----------------------------------------------------------------
- messages translations
-----------------------------------------------------------------*/
export default {
    success: {
        save_edit      : 'تغییرات با موفقیت ذخیره شد.',
        change_password: 'رمز عبور با موفقیت تغییر کرد.',
    },

    // Auth
    login: {
        success: 'خوش‌آمدید :)',
        error  : 'مشکلی در ورود شما به وجود آمده است. دوباره تلاش کنید.',
    },

    register: {
        success: 'ثبت نام با موفقیت انجام شد.',
        error  : 'در فرآیند ثبت نام مشکلی به وجود آمده است. دوباره تلاش کنید.',
    },
};
